<template>
  <div />
</template>
<script  >
import { mapActions, mapState } from 'vuex'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'
import { ROUTE_NAMES } from '@/constant/routes'

export default {
  name: 'FreePlanSection',
  mixins: [PaymentLocalizationMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  async mounted() {
    const { query } = this.$route
    await this.getCurrentUserAction()
    const { plan, promotion_code: promotionCode } = query
    if (!plan) { return }

    this.goToUpgradePage({
      plan,
      promotionCode,
      query: 'source=landing_site',
    })
  },

  methods: {
    ...mapActions(['createCheckoutSessionForPersonPlan', 'createCustomerPortalUpgradeFlowAction', 'getCurrentUserAction']),
    async goToUpgradePage(payload) {
      let errRes = null
      if (this.currentUser && this.currentUser.plan !== 'free' && !this.currentUser.plan.includes('one-time')) {
        errRes = await this.createCustomerPortalUpgradeFlowAction(payload)
      } else {
        errRes = await this.createCheckoutSessionForPersonPlan(payload)
      }

      // for success action, it will be redirect to stripe without bodyText
      // so, here, we encounted an error. Just fallback to My plan page
      if (errRes?.bodyText != null) {
        this.$router.push({ name: ROUTE_NAMES.USER_PLAN })
      }
    },
  },

}
</script>
